
import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'
import { SHA256 } from 'crypto-js'
import authService from '../auth/oidc'

import Login from '../views/LoginView.vue'
import AuthCallback from '../views/AuthCallbackView.vue'
import ResetSenha from '../views/ResetSenhaView.vue'
import Home from '../views/HomeView.vue'
import GrupoTelas from '../views/Adm/GrupoTelasView.vue'
import CadastroTelas from '../views/Adm/CadastroTelasView.vue'
import ControleSmtp from '../views/Adm/ControleSmtpView.vue'
import CadastroTipoUsuario from '../views/Adm/CadastroTipoUsuarioView.vue'
import CadastroTipoCliente from '../views/Adm/CadastroTipoClienteView.vue'
import CadastroUsuarios from '../views/Usuarios/CadastroUsuariosView.vue'
import CadastroAvisoSistema from '../views/Adm/CadastroAvisoSistemaView.vue'
import ControlePermissoesPerfil from '../views/Usuarios/ControlePermissoesPerfilView.vue'
import CadastroTipoPessoas from '../views/Usuarios/CadastroTipoPessoasView.vue'
import CadastroTipoDocumento from '../views/Adm/CadastroTipoDocumentoView.vue'
import CadastroListaDocumento from '../views/Adm/CadastroListaDocumentoView.vue'
import CadastroDocumentosSinistros from '../views/Adm/CadastroDocumentosSinistrosView.vue'
import CadastroTipoOperadora from '../views/Adm/CadastroTipoOperadoraView.vue'
import CadastroProdutosConsulta from '../views/Adm/CadastroProdutosConsultaView.vue'
import CadastroFormasPagamento from '../views/Adm/CadastroFormasPagamentoView.vue'
import CadastroMensagensPadrao from '../views/Cadastros/CadastroMensagensPadraoView.vue'
import CadastroDuvidasFrequentes from '../views/Adm/CadastroDuvidasFrequentesView.vue'
import CadastroPlanosGarantePay from '../views/Adm/CadastroPlanosGarantePayView.vue'
import CadastroModelosContratos from '../views/Adm/CadastroModelosContratosView.vue'
import CadastroListaServicosExtras from '../views/Adm/CadastroListaServicosExtrasView.vue'
import SegmentosProd from '../views/Produtos/SegmentosProdView.vue'
import Produtos from '../views/Produtos/ProProdutosView.vue'

import Garantidoras from '../views/Garantidoras/GarantidorasView.vue'
import RecargaConsultas from '../views/Garantidoras/RecargaConsultasView.vue'
import ControleCobrancas from '../views/Cobrancas/ControleCobrancasView.vue'
import TotalMensalCobranca from '../views/Cobrancas/TotalMensalCobrancaView.vue'
import TotalAnualCobranca from '../views/Cobrancas/TotalAnualCobrancaView.vue'

import ControleCobrancasImobiliarias from '../views/CobrancasImobiliaria/ControleCobrancasImobiliariasView.vue'

import Parceiros from '../views/Parceiros/ParceirosView.vue'

import Imobiliarias from '../views/Imobiliarias/ImobiliariasView.vue'

import Clientes from '../views/Clientes/ClientesView.vue'

import Garantepay from '../views/GarantePay/GarantepayView.vue'
import ControleCobrancasGarantePay from '../views/GarantePay/ControleCobrancasGarantePayView.vue'
import TotalMensalPrevistoGarantePay from '../views/GarantePay/TotalMensalPrevistoGarantePayView.vue'
import TotalAnualPrevistoGarantePay from '../views/GarantePay/TotalAnualPrevistoGarantePayView.vue'

import SupTiposChamados from '../views/Suporte/SupTiposChamadosView.vue'
import CadastroChamados from '../views/Suporte/CadastroChamadosView.vue'
import ChamadosAndamento from '../views/Suporte/ChamadosAndamentoView.vue'

import RelatorioContratosAtivos from '../views/Relatorios/RelatorioContratosAtivosView.vue'
import RelatorioContratosAVencer from '../views/Relatorios/RelatorioContratosAVencerView.vue'
import RelatorioContratosEncerrados from '../views/Relatorios/RelatorioContratosEncerradosView.vue'
import RelatorioProvisaoSinistros from '../views/Relatorios/RelatorioProvisaoSinistrosView.vue'
import RelatorioConcentracaoContratosAtivos from '../views/Relatorios/RelatorioConcentracaoContratosAtivosView.vue'
import RelatorioEvolucaoCarteira from '../views/Relatorios/RelatorioEvolucaoCarteiraView.vue'


import ListaContratacoes from '../views/Pedidos/ListaContratacoesView.vue'
import ListaContratacoesVigentes from '../views/Pedidos/ListaContratacoesVigentesView.vue'
import ContratacaoDetalhe from '../views/Pedidos/ContratacaoDetalheView.vue'
import NovaContratacao from '../views/Pedidos/NovaContratacaoView.vue'
import NovaContratacaoGarantia from '../views/Pedidos/NovaContratacaoView.vue'
import ContratacoesNegadoCancelado from '../views/Pedidos/ContratacoesNegadoCanceladoView.vue'
import ContratacaoNegadaDetalhe from '../views/Pedidos/ContratacaoNegadaDetalheView.vue'
import ContratacaoVigenteDetalhe from '../views/Pedidos/ContratacaoVigenteDetalheView.vue'
import ListaContratacoesVigenciaFinalizada from '../views/Pedidos/ListaContratacoesVigenciaFinalizadaView.vue'
import ContratacaoVigenciaFinalizadaDetalhe from '../views/Pedidos/ContratacaoVigenciaFinalizadaDetalheView.vue'

import TombamentoPlanilha from '../views/Pedidos/TombamentoPlanilhaView.vue'

import ListaSinistros from '../views/Sinistros/ListaSinistrosView.vue'
import ListaSinistrosAprovacao from '../views/Sinistros/ListaSinistrosAprovacaoView.vue'
import CadastroSinistros from '../views/Sinistros/CadastroSinistrosView.vue'
import SinistroAprovacaoDetalhe from '../views/Sinistros/SinistroAprovacaoDetalheView.vue'
import ListaSinistrosPagamento from '../views/Sinistros/ListaSinistrosPagamentoView.vue'
import SinistroPagamentoDetalhe from '../views/Sinistros/SinistroPagamentoDetalheView.vue'
import ListaSinistrosCobranca from '../views/Sinistros/ListaSinistrosCobrancaView.vue'
import SinistroCobrancaDetalhe from '../views/Sinistros/SinistroCobrancaDetalheView.vue'
import ListaSinistrosAcordo from '../views/Sinistros/ListaSinistrosAcordoView.vue'
import SinistroAcordoDetalhe from '../views/Sinistros/SinistroAcordoDetalheView.vue'
import ListaSinistrosAcordoParcelas from '../views/Sinistros/ListaSinistrosAcordoParcelasView.vue'


const routes = [
  { path: '/callback', name: 'AuthCallbackShort', component: AuthCallback, meta: { hideHeader: true } },
  { path: '/auth/callback', name: 'AuthCallback', component: AuthCallback, meta: { hideHeader: true } },
  { path: '/:id?/:garantidora?', name: 'login', component: Login,  meta: { hideHeader: true } },
  { path: '/Home', name: 'Home', component: Home },
  { path: '/ResetSenha/:id/:key', name: 'ResetSenha', component: ResetSenha, meta: { hideHeader: true } },
  { path: '/GrupoTelas/', name: 'GrupoTelas', component: GrupoTelas },
  { path: '/CadastroTelas', name: 'CadastroTelas', component: CadastroTelas },
  { path: '/ControleSmtp', name: 'ControleSmtp', component: ControleSmtp },
  { path: '/CadastroTipoUsuario', name: 'CadastroTipoUsuario', component: CadastroTipoUsuario },
  { path: '/CadastroTipoCliente', name: 'CadastroTipoCliente', component: CadastroTipoCliente },
  { path: '/CadastroUsuarios/:id?', name: 'CadastroUsuarios', component: CadastroUsuarios },
  { path: '/ControlePermissoesPerfil', name: 'ControlePermissoesPerfil', component: ControlePermissoesPerfil },
  { path: '/CadastroTipoPessoas', name: 'CadastroTipoPessoas', component: CadastroTipoPessoas },
  { path: '/CadastroTipoDocumento', name: 'CadastroTipoDocumento', component: CadastroTipoDocumento },
  { path: '/CadastroAvisoSistema', name: 'CadastroAvisoSistema', component: CadastroAvisoSistema },
  { path: '/CadastroListaServicosExtras', name: 'CadastroListaServicosExtras', component: CadastroListaServicosExtras },
  { path: '/CadastroListaDocumento', name: 'CadastroListaDocumento', component: CadastroListaDocumento },
   { path: '/CadastroDocumentosSinistros', name: 'CadastroDocumentosSinistros', component: CadastroDocumentosSinistros },
  { path: '/CadastroTipoOperadora', name: 'CadastroTipoOperadora', component: CadastroTipoOperadora },
  { path: '/CadastroProdutosConsulta', name: 'CadastroProdutosConsulta', component: CadastroProdutosConsulta },
  { path: '/CadastroFormasPagamento', name: 'CadastroFormasPagamento', component: CadastroFormasPagamento },
  { path: '/CadastroMensagensPadrao', name: 'CadastroMensagensPadrao', component: CadastroMensagensPadrao },
  { path: '/CadastroDuvidasFrequentes', name: 'CadastroDuvidasFrequentes', component: CadastroDuvidasFrequentes },
  { path: '/CadastroPlanosGarantePay', name: 'CadastroPlanosGarantePay', component: CadastroPlanosGarantePay },
  { path: '/CadastroModelosContratos', name: 'CadastroModelosContratos', component: CadastroModelosContratos },
  { path: '/SegmentosProdutos', name: 'SegmentosProd', component: SegmentosProd },
  { path: '/Produtos', name: 'Produtos', component: Produtos },

  
  { path: '/Garantidoras', name: 'Garantidoras', component: Garantidoras },
  { path: '/RecargaConsultas', name: 'RecargaConsultas', component: RecargaConsultas },
  { path: '/ControleCobrancas', name: 'ControleCobrancas', component: ControleCobrancas },
  { path: '/TotalMensalCobranca', name: 'TotalMensalCobranca', component: TotalMensalCobranca },
    { path: '/TotalAnualCobranca', name: 'TotalAnualCobranca', component: TotalAnualCobranca },
  { path: '/cobrancasimobiliarias', name: 'ControleCobrancasImobiliarias', component: ControleCobrancasImobiliarias },


  { path: '/Parceiros', name: 'Parceiros', component: Parceiros },
  { path: '/Imobiliarias', name: 'Imobiliarias', component: Imobiliarias },
  { path: '/Clientes', name: 'Clientes', component: Clientes },

  { path: '/Garantepay', name: 'Garantepay', component: Garantepay },
  { path: '/ControleCobrancasGarantePay', name: 'ControleCobrancasGarantePay', component: ControleCobrancasGarantePay },
  { path: '/TotalMensalPrevistoGarantePay', name: 'TotalMensalPrevistoGarantePay', component: TotalMensalPrevistoGarantePay },
  { path: '/TotalAnualPrevistoGarantePay', name: 'TotalAnualPrevistoGarantePay', component: TotalAnualPrevistoGarantePay },
  

  { path: '/SupTiposChamados', name: 'SupTiposChamados', component: SupTiposChamados },
  { path: '/CadastroChamados', name: 'CadastroChamados', component: CadastroChamados },
  { path: '/ChamadosAndamento', name: 'ChamadosAndamento', component: ChamadosAndamento },

  { path: '/RelatorioContratosAtivos', name: 'RelatorioContratosAtivos', component: RelatorioContratosAtivos },
  { path: '/RelatorioContratosAVencer', name: 'RelatorioContratosAVencer', component: RelatorioContratosAVencer },
  { path: '/RelatorioContratosEncerrados', name: 'RelatorioContratosEncerrados', component: RelatorioContratosEncerrados },
  { path: '/RelatorioProvisaoSinistros', name: 'RelatorioProvisaoSinistros', component: RelatorioProvisaoSinistros },
  { path: '/RelatorioConcentracaoContratosAtivos', name: 'RelatorioConcentracaoContratosAtivos', component: RelatorioConcentracaoContratosAtivos },
  { path: '/RelatorioEvolucaoCarteira', name: 'RelatorioEvolucaoCarteira', component: RelatorioEvolucaoCarteira },
  
  
  { path: '/ListaContratacoes', name: 'ListaContratacoes', component: ListaContratacoes },
  { path: '/ListaContratacoesVigentes', name: 'ListaContratacoesVigentes', component: ListaContratacoesVigentes },
  { path: '/ContratacaoDetalhe/:idPed', name: 'ContratacaoDetalhe', component: ContratacaoDetalhe },
  { path: '/NovaContratacao', name: 'NovaContratacao', component: NovaContratacao },
   { path: '/NovaContratacaoGarantia', name: 'NovaContratacaoGarantia', component: NovaContratacaoGarantia },
  { path: '/ContratacoesNegadoCancelado', name: 'ContratacoesNegadoCancelado', component: ContratacoesNegadoCancelado },
  { path: '/ContratacaoNegadaDetalhe/:idPed', name: 'ContratacaoNegadaDetalhe', component: ContratacaoNegadaDetalhe },
  { path: '/ContratacaoVigenteDetalhe/:idPed', name: 'ContratacaoVigenteDetalhe', component: ContratacaoVigenteDetalhe },
  { path: '/ListaContratacoesVigenciaFinalizada', name: 'ListaContratacoesVigenciaFinalizada', component: ListaContratacoesVigenciaFinalizada },
  { path: '/ContratacaoVigenciaFinalizadaDetalhe/:idPed', name: 'ContratacaoVigenciaFinalizadaDetalhe', component: ContratacaoVigenciaFinalizadaDetalhe },
  { path: '/TombamentoPlanilha', name: 'TombamentoPlanilha', component: TombamentoPlanilha },

   { path: '/ListaSinistros', name: 'ListaSinistros', component: ListaSinistros },
   { path: '/ListaSinistrosAprovacao', name: 'ListaSinistrosAprovacao', component: ListaSinistrosAprovacao },
   { path: '/ListaSinistrosPagamento', name: 'ListaSinistrosPagamento', component: ListaSinistrosPagamento },
   { path: '/ListaSinistrosCobranca', name: 'ListaSinistrosCobranca', component: ListaSinistrosCobranca },
   { path: '/ListaSinistrosAcordo', name: 'ListaSinistrosAcordo', component: ListaSinistrosAcordo },
   { path: '/CadastroSinistros/:id?', name: 'CadastroSinistros', component: CadastroSinistros },
   { path: '/SinistroAprovacaoDetalhe/:id', name: 'SinistroAprovacaoDetalhe', component: SinistroAprovacaoDetalhe },
   { path: '/SinistroPagamentoDetalhe/:id', name: 'SinistroPagamentoDetalhe', component: SinistroPagamentoDetalhe },
   { path: '/SinistroCobrancaDetalhe/:id', name: 'SinistroCobrancaDetalhe', component: SinistroCobrancaDetalhe },
   { path: '/SinistroAcordoDetalhe/:id', name: 'SinistroAcordoDetalhe', component: SinistroAcordoDetalhe },
   { path: '/ListaSinistrosAcordoParcelas', name: 'ListaSinistrosAcordoParcelas', component: ListaSinistrosAcordoParcelas },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // 1) Sempre rola a página pro topo
  window.scrollTo({ top: 0, behavior: 'smooth' })

  // 2) Quais rotas NÃO precisam de autenticação
  const publicPages = ['ResetSenha', 'AuthCallback', 'AuthCallbackShort']
  const isPublic = publicPages.includes(to.name)

  if (isPublic) {
    // Se for rota de login ou reset, deixa passar
    return next()
  }

  try {
    if (await authService.isAuthenticated()) {
      if (to.name === 'login') {
        return next('/Home')
      }

      return next()
    }

    await authService.signInRedirect(to.fullPath)
  } catch (error) {
    console.error('Falha ao iniciar autenticacao OIDC.', error)
    return next(false)
  }
})



export default router
